import gql from 'graphql-tag';

import { listResourceQueryDefinitions } from '@/providers/graphql/resourceQueryDefinitions';

export const PARKING_SESSIONS_LIST_QUERY = gql`
	query ParkingSessionsList(
		$first: Int
		$after: String
		$where: ParkingSessionViewModelFilterInput
	) {
		parkingSessions(first: $first, after: $after, where: $where) {
			nodes {
				parkingSessionId
				facilityId
				ticketId
				entryDateTime
				exitDateTime
				status
				cancelReason
				paymentDateTime
				paymentAmount
				vehicleId
				parkingSessionTypeId
				paymentMethodId
				customerId
				parkingPositionId
				contractId
				vehicle {
					vehicleId
					plateNumber
					make
					model
					color
					vehicleType {
						name
					}
				}
				contract {
					contractId
					contractVehicles {
						contractVehicleId
						vehicleId
						rfidTag
					}
				}
				parkingSessionType {
					parkingSessionTypeId
					name
				}
				paymentMethod {
					paymentMethodId
					name
				}
				customer {
					customerId
					firmName
					firstName
					lastName
					isCompany
				}
				parkingPosition {
					parkingPositionId
					code
				}
				contract {
					contractId
					beginDate
					endDate
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;

export const PARKING_SESSION_DETAIL_QUERY = gql`
	query ParkingSessionDetail($parkingSessionId: Ulid!) {
		parkingSession(parkingSessionId: $parkingSessionId) {
			parkingSessionId
			facilityId
			ticketId
			entryDateTime
			exitDateTime
			status
			cancelReason
			paymentDateTime
			paymentAmount
			vehicleId
			parkingSessionTypeId
			paymentMethodId
			customerId
			parkingPositionId
			contractId
			cashierShiftId
			vehicle {
				vehicleId
				plateNumber
				make
				model
				color
				vehicleType {
					vehicleTypeId
					name
				}
			},
			contract {
				contractId
				contractVehicles {
					contractVehicleId
					vehicleId
					rfidTag
				}
			},
			parkingSessionType {
				parkingSessionTypeId
				name
			}
			paymentMethod {
				paymentMethodId
				name
			}
			customer {
				customerId
				firmName
				firstName
				lastName
				isCompany
				email
			}
			parkingPosition {
				parkingPositionId
				code
			}
			contract {
				contractId
				amount
				isActive
				customer {
					customerId
					firmName
					firstName
					lastName
					isCompany
				}
				contractVehicles {
					contractVehicleId
					vehicleId
					rfidTag
				}
			}
			cashierShift {
				cashierShiftId
				shiftStartDateTime
				shiftEndDateTime
				user {
					userId
					firstName
					lastName
				}
			}
			services {
				parkingSessionServiceId
				priceCharged
				service {
					serviceId
					description
					code
					price
				}
			}
			voucherParkingSessions {
				voucherParkingSessionId
				appliedAmount
				voucher {
					voucherId
					code
					name
					voucherDiscountType {
						name
					}
				}
			}
			aadeInvoices {
				aadeInvoiceId
				invoiceUid
				invoiceMark
				series
			}
			reservations {
				reservationId
				reservationStartTime
				reservationEndTime
				reservationStatus {
					name
				}
			}
		}
	}
`;

export const PARKING_SESSION_JOURNEY_LOGS_QUERY = gql`
	query ParkingSessionJourneyLogs($parkingSessionId: Ulid!, $first: Int = 50) {
		vehicleJourneyLogs(
			first: $first
			order: [{ eventTime: DESC }]
			where: { parkingSessionId: { eq: $parkingSessionId } }
		) {
			nodes {
				parkingSessionId
				vehicleJourneyLogId
				eventTime
				externalEventId
				additionalData
				vehicleJourneyEventType {
					name
				}
				terminal {
					name
					terminalType {
						name
					}
				}
				cashierShift {
					user {
						firstName
						lastName
					}
				}
			}
		}
	}
`;

export const PARKING_SESSION_CHARGE_LEDGER_QUERY = gql`
	query ParkingSessionChargeLedger($parkingSessionId: Ulid!) {
		parkingSession(parkingSessionId: $parkingSessionId) {
			parkingSessionId
			isInside#without this we cannot load the chargeLedgerEntries
			chargeLedgerEntries {
				chargeLedgerEntryId
				transactionDateTime
				computedCharge
				chargeAfterLimits
				amount
				description
				isReversed
				relatedEntityType
				relatedEntityId
				transactionType {
					transactionTypeId
					name
					code
					isDebit
				}
				paymentMethod {
					paymentMethodId
					name
				}
				lines {
					chargeLedgerEntryLineId
					lineSequence
					lineStartDateTime
					lineEndDateTime
					lineCharge
					description
					calculatedAt
				}
			}
		}
	}
`;

export const CHANGE_PARKING_SESSION_PLATE_NUMBER_MUTATION = gql`
	mutation ChangeParkingSessionPlateNumber($input: ChangeParkingSessionPlateNumberInput!) {
		changeParkingSessionPlateNumber(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const CREATE_PARKING_SESSION_MUTATION = gql`
	mutation CreateParkingSession($input: CreateParkingSessionInput!) {
		createParkingSession(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

listResourceQueryDefinitions['parkingSessions'] = {
	document: PARKING_SESSIONS_LIST_QUERY,
	dataPath: 'parkingSessions.nodes'
};
